import _ from 'lodash';
import {Record, List} from 'immutable';
/**
 * Application record abstract class.
 * @param  {Object} RecordAttribute Attribute you want your record to have
 * @return {Class}
 */
export default function(RecordAttribute) {
  const attributes = _.merge({id: -1, ID: -1, _embedded: {}}, RecordAttribute);
  return class ApplicationRecordWrapped extends Record(attributes) {
    /**
     * Get a _embedded attribute in the JSONAPI.
     * @param  {String}  relationName The name of the relation.
     *                                  For `_embedded.Team.items` do `Team`
     * @param  {Function<?>}  functor      Mapping function
     *                                      for every found item.
     * @return {List<?>}
     */
    _getMany(relationName, functor) {
      const count = _.get(this, `_embedded.${relationName}.count`);
      if (_.isNil(count) || count === 0) return new List();
      const items = _.get(this, `_embedded.${relationName}.items`);
      if (_.isNil(items))
        throw new Error(`${relationName}.items can not be null if count > 0`);
      return new List(items.map(functor));
    }

    /**
     * Get a _embedded
     * @param  {String}  relationName
     * @param  {Record<?>}  modelKlass
     * @return {Record<?>}
     */
    _getOne(relationName, modelKlass) {
      const item = _.get(this, `_embedded.${relationName}`);
      if (_.isNil(item)) return new modelKlass({});
      return new modelKlass(item);
    }
  };
}
